import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import RecruitmentOverview from "./index";
import { FaMagnifyingGlass } from "react-icons/fa6";

const overviewRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Overview",
        basePath: "recruitment",
        mainComponent: <RecruitmentOverview />,
        layout: "/console",
        icon: <FaMagnifyingGlass className="icon-item" />,
        subTitle:"Overviews",
        level:5,
        moduleId: 0,
    })
]

export default overviewRoutes;